import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "clockAlertFilled"
const ClockAlertFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M6.75 11.625C9.857 11.625 12.375 14.143 12.375 17.25S9.857 22.875 6.75 22.875 1.125 20.357 1.125 17.25 3.643 11.625 6.75 11.625M6.75 18.563C6.129 18.563 5.625 19.066 5.625 19.688 5.625 20.308 6.129 20.813 6.75 20.813S7.875 20.309 7.875 19.688C7.875 19.066 7.371 18.563 6.75 18.563M5.813 17.438H7.688V13.688H5.813z"
            clipRule="evenodd"
          />
          <path
            fillRule="evenodd"
            d="M13.125 1.5C18.303 1.5 22.5 5.697 22.5 10.875 22.5 16.023 18.35 20.201 13.213 20.249 13.637 19.337 13.875 18.322 13.875 17.25 13.875 13.315 10.685 10.125 6.75 10.125 5.678 10.125 4.662 10.363 3.75 10.786 3.799 5.65 7.978 1.5 13.126 1.5M12.75 11.186 15.97 14.406C16.555 13.818 16.555 12.87 15.97 12.283L14.25 10.564V6.376C14.25 5.547 13.578 4.875 12.75 4.875z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default ClockAlertFilledIcon
